<template>
    <div class="">
        <div class="row heading">
            <div class="col">
                <loading style="float:right;" :loading="loading" color="#5e9cd3"></loading>
                <h2>Lead Information

                    <dropdown-confirmation
                        v-show="!details.has_cashflow &&  $canAccess(8, 38)"
                        direction="left"
                        triggerBtnClass="btn-delete"
                        triggerBtnHtml='<i class="fa fa-trash"></i>&nbsp;&nbsp;Delete lead'
                        confirmBtnClass="btn-danger"
                        confirmBtnHtml='<i class="fa fa-exclamation"></i>&nbsp;&nbsp;Delete lead'
                        @confirm="deleteLead"
                    >
                        <slot>
                            Are you sure you want to permanently delete this lead?
                        </slot>
                    </dropdown-confirmation>



                    <dropdown-confirmation

                            direction="left"
                            keepalive
                            triggerBtnClass="btn-light"
                            triggerBtnHtml='<i class="fa fa-plus"></i>&nbsp;&nbsp;Add Carrier'
                            confirmBtnClass="btn-primary"
                            confirmBtnHtml='<i class="fa fa-plus"></i>&nbsp;&nbsp;Add Carrier'
                            @confirm="addCarrier"
                    >
                        <slot>
                            <label>Choose a carrier</label>
                            <auto-complete
                                :list="carriers.map(c => c.name)"
                                :selection="carrier.name"
                                @change="setCarrier"
                                @cancel="revertCarrier"
                            ></auto-complete>
                        </slot>
                    </dropdown-confirmation>


                </h2>

            </div>
            <div class="col text-right" v-show="editing">
              <button @click="save" class="btn btn-sm btn-success">
                <i class="fa fa-check"></i> &nbsp;Save
              </button>
              <button @click="cancel" class="btn btn-sm btn-danger">
                <i class="fa fa-remove"></i> &nbsp;Cancel
              </button>
            </div>
        </div>
        <div class="row">
            <div class="col col-form-label"><label>Name</label></div>
            <div class="col-md-4" @click="editFields('name')" >
                <div class="col-form-label"  v-show="!editing">
                  {{details.name}}
                  <i class="editable-icon float-right fa fa-pencil text-muted"> </i>
                </div>
                <span v-show="editing">
                    <input
                        class="form-control"
                        type="text"
                        v-model="selected.name"
                        @keydown.enter="save"
                    />
                </span>
            </div>
            <div class="col col-form-label"><label>Billing Address</label></div>
            <div class="col-md-4" @click="editFields('created_on')" v-if="details.location">
              <div class="col-form-label" v-show="!editing">
                <div v-show="details.location.formatted_address">
                  {{details.location.formatted_address}}&nbsp;&nbsp;
                  <img class="minimap d-inline-block" @click.stop="showMap = true;" src="/static/images/mapicon.png">
                </div>
                <div v-show="!details.location.formatted_address">
                  -
                </div>

              </div>
              <span v-show="editing">
                  <auto-complete
                    loose
                    placeholder="Enter Lead Address"
                    :list="addressNames"
                    :selection="getSelectedAddress"
                    @input="findAddresses"
                    @change="setAddress"
                    @enter="save"
                    @cancel="revertAddress"
                  ></auto-complete>
              </span>
            </div>
        </div>

        <div class="row">
            <div class="col col-form-label text-truncate">
                <label>Created On</label>
            </div>
            <div class="col-md-4 editable col-form-label"  >
                <div v-show="!editing" @click="editFields('created_on')">

                    {{ details.created_on | formatDate }}
                    <i class="editable-icon float-right fa fa-pencil text-muted"></i>
                </div>
                <span v-show="editing" >
                  <div class="input-group">
                    <datepicker
                            tabindex="3"
                            input-class="form-control"
                            wrapper-class="datepicker-wrapper input-group"
                            :value="selected.created_on | formatDate"
                            @selected="setStartDate"
                            format="MM/dd/yyyy"
                    ></datepicker>
                    <div class="input-group-addon clear">
                      <i class="fa fa-calendar"></i>
                    </div>
                  </div>
                </span>
            </div>
            <div class="col col-form-label text-truncate">
                <label>Followup</label>
            </div>

            <div class="col-md-4 editable col-form-label"  >
                <div v-show="!editing" @click="editFields('followup')">

                    {{ details.followup | formatDate }}
                    <i class="editable-icon float-right fa fa-pencil text-muted"></i>
                </div>
                <span v-show="editing" >
                  <div class="input-group">
                    <datepicker
                            tabindex="3"
                            input-class="form-control"
                            wrapper-class="datepicker-wrapper input-group"
                            :value="selected.followup | formatDate"
                            @selected="setFollowupDate"
                            format="MM/dd/yyyy"
                    ></datepicker>
                    <div class="input-group-addon clear">
                      <i class="fa fa-calendar"></i>
                    </div>
                  </div>
                </span>
            </div>
        </div>


      <modal v-if="showMap" size="lg" allow-click-away="false">
        <div slot="header">
          <h3 class="modal-title d-inline d-flex justify-content-start">Choose Providers</h3>
          <button @click="showMap = false" type="button" class="btn btn-clear close-btn" >
            <i class="fa fa-remove"  />
          </button>
        </div>

        <mini-map size="lg" slot="body" :address="details.location" :carriers="carriers" @close="showMap = false">
        </mini-map>
      </modal>
    </div>
</template>
<script type="text/babel">
    import Dropdown from '../assets/Dropdown.vue';
    import Loading from 'vue-spinner/src/PulseLoader.vue';
    import Modal from '../assets/Modal.vue';
    import MiniMap from '../includes/MiniMap.vue';
    import AutoComplete  from '../assets/Autocomplete.vue';
    import Datepicker from 'vuejs-datepicker';
    import { mixin as clickaway } from 'vue-clickaway';

    import DropdownConfirmation from '../assets/DropdownConfirmation.vue';


    export default {
        name:'leadInformation',
        data:function(){
            return{
              params: {
                function: 'details',
                data: {
                  lead_id: ''
                }
              },
                leadCarriers:[],
              cachedValue: null,
              editing: false,
              map: {},
              addresses:[],
              showMap: false,
                carrier:{
                    name: '',
                    carrier_id: ''
                },
              selected: {
                name: '',
                created_on: '',
                followup: '',
                address:{
                  address: '',
                  geolng: '',
                  geolat: '',
                  city: '',
                  state: '',
                  zip: '',
                  neighborhood: '',
                  formatted_address: ''
                }
              },
                showAddCarrier: false,
                loading:false,
                terms: ["1 month", "12 months", "24 months", "36 months", "60 months"]
          }
        },
        mixins: [ clickaway ],
        components:{
          Dropdown,
          Datepicker,
          AutoComplete,
          Modal,
          MiniMap,
          Loading,
          DropdownConfirmation,

        },
        computed:{
          getSelectedAddress(){
            if(this.selected.location){
              return this.selected.location.formatted_address
            }
            return '';
          },
          addressNames(){
              return this.addresses.map(function(a){
                return a.formatted_address;
              })
          },
          getStatusList(){
              return this.leadStatuses.map(function(status){
                  return status.name;
              });
          },
          getStatusName(){
              var _this = this;
              if(!this.leadStatuses) return false;
              return this.leadStatuses.filter(function(s){

                  if(_this.editing){
                    return s.id == _this.selected.status_id;
                  } else {
                    return s.id == _this.details.status_id;
                  }
              }).map(function(s){

                  return s.name;
              })[0];
          }
        },
        created(){
            this.map = new window.TCMap();
            this.params.data.lead_id = this.$route.params.lead_id;
        },
        directives: {
          'input-focus': function (el, value) {
            if (value) {
              el.focus()
            }
          }
        },
        filters:{
            getLabel(id){
                return this.statuses.filter(function(status){
                    return status.id == id;
                }).map(function(status){
                    return status.name;
                });
            },
            formatDate(date){
                if(!date) return null;
                return moment(date, 'YYYY-MM-DD').format('MM/DD/YYYY');
            }
        },
        props:{
          details: {
            type: Object
          },
          carriers:{
          },
          mrc: {}
        },
        methods:{

            revertCarrier(){
                this.carrier = {
                    name: '',
                    carrier_id: ''
                }
            },
            setCarrier(carrier_name){
                var carriers = this.carriers.filter(c => c.name == carrier_name)
                this.carrier = carriers.length ? carriers[0]:  null;
            },
            addCarrier(){
                this.$send(this, 'leadCarrierCreate',{
                    carrier_id: this.carrier.carrier_id,
                    lead_id: this.params.data.lead_id
                }).then(r => {
                    this.$emit('leadCarrierUpdate');
                });
            },

            deleteLead(){
                this.$send(this, 'leadDelete',{
                    lead_id: this.params.data.lead_id
                }).then(r => {
                    this.$router.replace('/leads')
                });
            },

            mergeleads(merge_lead_id){
                this.$send(this, 'leadMerge', {
                    lead_id: this.params.data.lead_id,
                    new_lead_id: merge_lead_id
                }).then(r => {

                });
            },

            nextField($event){
                $event.target.nextElementSibling.focus()
            },
            save(){
                var _this = this;
                this.loading = true;
                this.$emit( 'leadUpdate', {
                    name: this.selected.name,
//                    status_id: this.selected.status_id,
                    location: this.selected.location.formatted_address,
                    followup: this.selected.followup,
//                    term: this.selected.term,
//                    ink_date: this.selected.ink_date,
//                    carrier_lead_number: this.selected.carrier_lead_number,
//                    carrier_opportunity_number: this.selected.carrier_opportunity_number,
                    created_on: this.selected.created_on
                });
                this.$nextTick(function(){
                    _this.cancel();
                });
          },
          cancel(){
            this.editing = null;
            this.selected = {
                name: '',
                created_on: '',
                followup: '',
                location:{
                    address: '',
                    geolat: '',
                    geolat: '',
                    city: '',
                    state: '',
                    zip: '',
                    neighborhood: '',
                    formatted_address: ''
                }
            }
          },
          revertAddress(){
              var details = JSON.parse(JSON.stringify(this.details));
              this.selected.location = details.location;
          },
          findAddresses(address){
              this.selected.location.formatted_address = address;
              this.searchGoogle(address);
          },
          searchGoogle: _.debounce(function(address) {
            var _this = this;
            this.map.search(address, function (err, data) {
              if (err) {
                console.error(err);
              } else {
                _this.addresses = data;
              }
            })
          }, 500),




          setAddress(address){
            var _this = this;


            this.address = this.addresses.filter(function(a){
              return a.formatted_address == address;
            }).map(function(a){

              var data = {
                formatted_address: a.formatted_address,
                geolat: a.geometry.location.lat(),
                geolong: a.geometry.location.lng(),
                address: a.address_components[0].short_name + ' ' + a.address_components[1].short_name
              };
              if(a.address_components[2]) data.neighborhood =  a.address_components[2].short_name;
              if(a.address_components[3]) data.city =  a.address_components[2].short_name;
              if(a.address_components[5]) data.state =  a.address_components[5].short_name;
              if(a.address_components[6]) data.country =  a.address_components[6].short_name;
              if(a.address_components[7]) data.zip =  a.address_components[7].short_name;
              return data;
            })[0];

            if(this.address){
              this.selected.location = this.address;
            } else {
              this.selected.location = {};
            }
          },
            editFields(field){

                if(!this.editing){
                    this.editing = field;
                    this.selected = JSON.parse(JSON.stringify(this.details));
                }
            },
            setStartDate(value){
                this.selected.created_on = moment(value, 'MM/DD/YYYY').format('YYYY-MM-DD');
                this.save();
            },

            setFollowupDate(value){
                this.selected.followup = moment(value, 'MM/DD/YYYY').format('YYYY-MM-DD');
                this.save();
            },
            setStatus(statusName){
                this.selected.status_id = this.leadStatuses.filter(function(status){
                    return status.name == statusName;
                }).map(function(status){
                    return status.id;
                })[0];
                console.log( this.selected.status_id );
                this.save();
          },
          showMap(){
              console.log('showmap');
          },

          fetchStatuses(){

              this.$send(this, 'leadStatuses').then(r => {
                  this.leadStatuses = r.leadStatuses;
              });

          },
        },
        watch:{
            details: function(newDetails){
               this.loading = false;
            }
        }


    }

</script>
<style scoped>
  .editable-icon{
    display:none;
  }
  .editable{
    cursor:pointer;
  }
  .editable:hover .editable-icon{
    display:block;
  }


</style>



// WEBPACK FOOTER //
// LeadInformation.vue?08ccf8e8